export default __webpack_public_path__ + "static/media/not_found.b0257582.png";